export const dictTreeList = {};
export const dictList = {
  ROLE_TYPE: [
    {dictValue: 'sys_admin', dictLabel: '管理员角色', dictStyle: 'danger'},
    {dictValue: 'default', dictLabel: '普通角色', dictStyle: 'info'},
    {dictValue: 'dev_approve', dictLabel: '开发审批者', dictStyle: 'success'},
    {dictValue: 'biz_approve', dictLabel: '业务审批者', dictStyle: 'success'},
  ],
  // TERMINAL_SITE_TYPE: [
  //   {dictValue: 'TERMINAL_SITE_AREA', dictLabel: '站点(地区)'},
  //   {dictValue: 'TERMINAL_SITE_PROD', dictLabel: '站点(生产)'},
  //   {dictValue: 'TERMINAL_SITE_FZ_PROD', dictLabel: '站点(仿真-生产)'},
  //   {dictValue: 'TERMINAL_SITE_MAIN', dictLabel: '站点(主)'},
  //   {dictValue: 'TERMINAL_SITE_MAIN_BAK', dictLabel: '站点(主-备)'},
  // ],
  // TERMINAL_SITE_AREA: [
  //   {dictValue: 'shanghai', dictLabel: '上海', dictStyle: 'success'},
  //   {dictValue: 'hangzhou', dictLabel: '杭州', dictStyle: 'danger'},
  // ],
  // TERMINAL_SITE_PROD: [
  //   {dictValue: 'prod', dictLabel: '主节点', dictStyle: 'success'},
  // ],
  // TERMINAL_SITE_FZ_PROD: [
  //   {dictValue: 'fz', dictLabel: '仿真', dictStyle: 'success'},
  //   {dictValue: 'prod', dictLabel: '生产', dictStyle: 'danger'},
  // ],
  // TERMINAL_SITE_MAIN: [
  //   {dictValue: 'main', dictLabel: '主节点', dictStyle: 'success'},
  // ],
  // TERMINAL_SITE_MAIN_BAK: [
  //   {dictValue: 'main', dictLabel: '主节点', dictStyle: 'success'},
  //   {dictValue: 'bak', dictLabel: '备节点', dictStyle: 'danger'},
  // ],
  /**
   * 服务日志名
   */
  SERVER_NAME: [
    {dictValue: 'uams-auth.log', dictLabel: '统一认证授权服务'},
    {dictValue: 'uams-admin.log', dictLabel: '统一认证管理服务'},
    {dictValue: 'hc-sunflower.log', dictLabel: '开发平台'},
  ],
};
export default {dictList: dictList, dictTreeList: dictTreeList};
